import axiosInstance from '../utils/axios';

const API_BASE = '/api/v2';

// Path "anuncios" (nao "ads"): ad blockers bloqueiam URLs com /ads/.
const mktAnunciosService = {
    listar: async (clienteId, params = {}) => {
        const response = await axiosInstance.get(`${API_BASE}/${clienteId}/mkt/anuncios`, { params });
        return response.data;
    },

    buscar: async (id) => {
        const response = await axiosInstance.get(`${API_BASE}/mkt/anuncios/${id}`);
        return response.data;
    },

    insights: async (id, params = {}) => {
        const response = await axiosInstance.get(`${API_BASE}/mkt/anuncios/${id}/insights`, { params });
        return response.data;
    },

    sincronizar: async (clienteId, body = {}) => {
        // Sync pode demorar com varias contas; sem timeout o botao fica
        // "Sincronizando..." indefinidamente se a Meta travar.
        const response = await axiosInstance.post(
            `${API_BASE}/${clienteId}/mkt/anuncios/sync`,
            body,
            { timeout: 90000 }
        );
        return response.data;
    },

    capacidades: async (clienteId) => {
        const response = await axiosInstance.get(`${API_BASE}/${clienteId}/mkt/anuncios/capabilities`);
        return response.data;
    }
};

export default mktAnunciosService;
